function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './index.scss'; ////////// Setup

var CREATE_CLOSE_ICON = null;
export function setup(options) {
  if (typeof options.createCloseIcon === 'function') {
    CREATE_CLOSE_ICON = options.createCloseIcon;
  }
} ////////// Element

var AlertBox = /*#__PURE__*/function (_HTMLElement) {
  _inherits(AlertBox, _HTMLElement);

  var _super = _createSuper(AlertBox);

  function AlertBox(options) {
    var _this;

    _classCallCheck(this, AlertBox);

    _this = _super.call(this);

    if (options) {
      if (options.color) {
        _this.classList.add("alert-box--color-".concat(options.color));
      }

      _this.title = options.title;
      _this.body = options.body;

      _this.createElements();
    }

    return _this;
  }

  _createClass(AlertBox, [{
    key: "createElements",
    value: function createElements() {
      var _this2 = this;

      // Header
      var headerElement = document.createElement('div');
      headerElement.classList.add('alert-box__header');
      this.appendChild(headerElement);
      var titleElement = document.createElement('div');
      titleElement.classList.add('alert-box__title');
      titleElement.innerText = this.title;
      headerElement.appendChild(titleElement);
      var closeButton = document.createElement('a');
      closeButton.classList.add('alert-box__close');
      closeButton.addEventListener('click', function (_event) {
        return _this2.closeClicked();
      });
      headerElement.appendChild(closeButton);

      if (CREATE_CLOSE_ICON) {
        this.closeIcon = CREATE_CLOSE_ICON();
        closeButton.appendChild(this.closeIcon);
      } // Body


      var bodyElement = document.createElement('div');
      bodyElement.classList.add('alert-box__body');
      bodyElement.innerHTML = this.body;
      this.appendChild(bodyElement);
    } ////////// Actions

  }, {
    key: "closeClicked",
    value: function closeClicked() {
      var _this3 = this;

      this.classList.add('alert-box--hidden');
      setTimeout(function () {
        return _this3.remove();
      }, 500);
    }
  }]);

  return AlertBox;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

window.customElements.define('alert-box', AlertBox); //////////

AlertBox.showAlert = function (options) {
  var modalContainer = document.querySelector('#modal-alerts');
  var alert = new AlertBox(options);
  alert.classList.add('alert-box--hidden');
  modalContainer.appendChild(alert);
  setTimeout(function () {
    return alert.classList.remove('alert-box--hidden');
  });
};

window.AlertBox = AlertBox; //////////

document.addEventListener('turboujs:load', function (_event) {
  if (window.modalAlerts) {
    window.modalAlerts.forEach(function (options) {
      AlertBox.showAlert(options);
    });
  }
});